'use client';
var Transformer = function(transforms) {
    var skip = function skip(eventName, payload) {
        return payload;
    };
    var reduce = function reduce(eventName, payload) {
        return cleanTransforms.reduce(function(target, transform) {
            return transform(eventName, target);
        }, payload);
    };
    var cleanTransforms = transforms.filter(Boolean);
    var transformer = {
        reduce: transforms.length ? reduce : skip
    };
    return transformer;
};

export { Transformer };
